import React, { useState } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import Image from "next/image";
import {
  hero_3_swiper_data,
  hero_3_swiper_thumbs_data,
} from "../../data/hero_3_swiper_data";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
export const baseURL = `https://devapi.impactoverse.com/`;
const SingleSocialSlider = ({ filter }) => {
  const [activeThumb, setActiveThumb] = useState(null);
  return (

    <>
      {/* <!-- Hero Slider --> */}
      <section className="relative">
        <Swiper
          modules={[FreeMode, Navigation, Thumbs]}
          loop={true}
          spaceBetween={10}
          navigation={true}
          thumbs={{
            swiper: activeThumb && !activeThumb.destroyed ? activeThumb : null,
          }}
          // autoplay={{
          //   delay: 5000,
          //   disableOnInteraction: false,
          // }}
          className="full-slider my-height"
        >
          {
            filter.assets?.map((image, index) => {
              const { _id, discription, titleLink, userLink } = filter;
              return (
                <SwiperSlide key={index}>
                  <div className="swiper-slide after:bg-jacarta-900/60 after:absolute after:inset-0">
                    <div className="container relative z-10  pt-40">
                      <h2 className="font-display text-2xl font-semibold text-white">
                        {/* <Link href={_id}>{discription}</Link> */}
                      </h2>
                      <Link
                        href={_id}
                        className="text-2xs font-medium text-white"
                      >
                        {/* {discription} */}
                      </Link>
                    </div>

                    <Image
                      width={585}
                      height={455}
                      src={`${baseURL}${image}`}
                      className="absolute inset-0 h-full w-full object-fill"
                      alt={'dgg'}
                    />
                  </div>
                </SwiperSlide>
              );
            })
          }
        </Swiper>

        {/* <!-- Thumbs --> */}
        <div className="absolute inset-x-0 bottom-12">
          <div className="container">
            {/* <Thumbs_carousel /> */}
            <Swiper
              modules={[FreeMode, Navigation, Thumbs]}
              onSwiper={setActiveThumb}
              loop={false}
              spaceBetween={10}
              slidesPerView="auto"
              breakpoints={{
                100: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
              }}
              className=" full-slider-thumbs swiper-initialized swiper-horizontal swiper-pointer-events swiper-thumbs"
            >
              {
                filter.assets?.map((image, index) => {
                  return (
                    <SwiperSlide
                      className="swiper-slide cursor-pointer rounded p-5 swiper-slide-duplicate swiper-slide-duplicate-next "
                      key={index}
                    >
                      <Image
                        width={132}
                        height={77}
                        src={`${baseURL}${image}`}
                        className=" object-cover rounded-lg"
                        alt="thumb 1"
                        style={{ height: "77px" }}
                      />
                      <div className="carousel-progress relative -bottom-5 z-10 -ml-5 -mr-5 h-0.5 bg-white/20 ">
                        <div className="progress bg-accent absolute h-0.5 w-0"></div>
                      </div>
                    </SwiperSlide>
                  );
                })
              }
            </Swiper>
          </div>
        </div>
      </section>
    </>
  )
}

export default SingleSocialSlider
